<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div class="hero" id="home">
    <div class="shell shell--size-2">

        <div class="hero__media">

            <div class="hero__image heroImg"></div><!-- /.hero__image -->

            <!-- <p class="hero__play js-play"  target="_blank">
            <img src="assets/img/svg/ico-play.svg" alt="Play button">
        </p> -->
            <!-- /.hero__media -->


        </div>

        <div class="hero__content" *ngIf="!mobile">

            <div class="row">
                <h1 style="color: #5ECE42;">My Profile</h1>
            </div>

            <div class="row">
                You're now less than a minute from completing the Registration & Login process on Backseat-Trader and
                starting to enjoy the benefits offered.
            </div>

            <div class="row">
                You'll need your eToro account username
            </div>

            <div class="row">
                If you don't yet have an eToro account, not to worry; simply click:

            </div>

            <div class="row" style="margin-top:16%">
                <a [routerLink]="['/join-us']"
                    class="btnE joinUsBtnE" target="_blank" rel="noopener noreferrer" id="registerJoinUs" style="margin-bottom: 5%">Join us on
                    eToro</a><br/>
                    <div style="font-size: small; font-weight: normal; text-align: center;">Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div> 
            </div>


        </div><!-- /.hero__content -->
        <div class="hero__content" *ngIf="mobile">
            <!-- <div class="row">
                <h1 style="color: #5ECE42;">Creating your eToro account</h1>
            </div>
            
            <div class="row">
                You're now about to depart Backseat-Trader to establish your
                Copy Trading account on eToro.
            </div>
            
            <div class="row">
                To assist on this journey here are a couple of short videos
                covering the sign-up process:
            </div>
            
            <div class="row">
                <div class="col d-flex justify-content-center text-center my-auto">
                    <i class="fa-solid fa-photo-film fa-4x" style="color: #5ECE42;"></i>
                </div>
                <div class="col my-auto">
                    <div class="row">
                        <a href="#">Opening your account</a>
                    </div>
                    <div class="row">
                        <a href="#">Verifying your account</a>
                    </div>
                </div>
                
            </div>
            
            <div class="row" style="color: black">
                Once you've signed-up with eToro and have your Username
                you'll then need to return to Backseat-Trader to Register it with
                us, a process which takes less than a minute.
            </div>
            
            <div class="row" style="color: black">
                For a friendly reminder to return, click this link:
            </div>
            <br/>
            <div class="row">
                <div class="col text-center">
                    <a (click)="open(content)"><i class="fa-solid fa-bell fa-4x section__icon etoroBtnHowDesk" style="color: #5ECE42;"></i></a><br/>
                </div> -->


            <!-- </div> -->
            <div class="row">
                <h1 style="color: #5ECE42;">My Profile</h1>
            </div>
            <br /><br />

            <div class="row">
                You're now less than a minute from completing the Registration & Login process on Backseat-Trader and
                starting to enjoy the benefits offered.
            </div>
            <br /><br />

            <div class="row">
                You'll need your eToro account username
            </div>
            <br /><br />

            <div class="row">
                If you don't yet have an eToro account, not to worry; simply click:

            </div>

            <div class="row" style="margin-top:16%">
                <a [routerLink]="['/join-us']"
                    class="btnE joinUsBtnE" target="_blank" rel="noopener noreferrer" id="registerJoinUs" style="margin-bottom: 5%">Join us on
                    eToro</a><br/>
                    <div style="font-size: small; font-weight: normal; text-align: center;">Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div> 
            </div>
        </div><!-- /.hero__content -->
    </div><!-- /.shell -->
</div><!-- /.hero -->
<br /><br />
<div class="modal-dialog-centered" style="margin-bottom: -5%;">
    <div class="container screenPos" style="margin-top: -7%">
        <div class="container mt--8">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-7 cardPos">
                    <div class="card shadow" style="border-radius: 10px;">
                        <div class="card-header bg-transparent">
                            <div class="h3" style="text-align: center">REGISTER YOUR ETORO ACCOUNT
                                <button type="button" placement="top" style="border: none; background-color: white;"
                                    ngbPopover="Before registering with Backseat-Trader you must verify your existing eToro account first.">
                                    <i class="fa-solid fa-circle-info"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-lg-5 py-lg-5">
                            <form [formGroup]="registerform" role="form" class="needs-validation" novalidate>

                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                                        </div>
                                        <input type="username" formControlName="username" class="form-control"
                                            placeholder="Username Verification" aria-describedby="inputGroupPrepend"
                                            style="height:5rem; 
                                            font-size:medium" required>
                                        <div class="input-group-append" style=" text-align: center">
                                            <button type="button" class="btn-primary text-center" (click)="verify()"
                                                style="padding-left:2rem; padding-right:2rem"
                                                *ngIf="!verifLoading && !success">
                                                <i class="fas fa-search text-white"></i>
                                            </button>
                                            <div class="spinner-border text-primary" role="status"
                                                *ngIf="verifLoading && !success"
                                                style="width: 3rem; height: 3rem; margin-left: 10px">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <div *ngIf="success">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fa fa-check fa-4x"
                                                            aria-hidden="true"
                                                            style="color: green; margin-bottom: 2px"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="!verifStatus" style="font-size:small">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        {{verifText}} <span *ngIf="counterExcess">({{theVerifCounter}})</span>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="noVerifStatus" style="font-size:small">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        {{noVerifText}}
                                    </div>
                                    <div class="d-block" *ngIf="success" style="font-size:small; color: green">
                                        <i class="fa fa-check"></i> &nbsp;
                                        {{successText}}
                                    </div>
                                </div>
                                <!-- <br /><br /> --><span *ngIf="mobile"><br /><br /></span>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                        </div>
                                        <input type="email" formControlName="email" class="form-control"
                                            placeholder="Email" aria-describedby="inputGroupPrepend"
                                            style="height:5rem; font-size:medium" required>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="submitted && f.email.errors">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        Email is required
                                    </div>
                                </div>
                                <!-- <br /><br /> --><span *ngIf="mobile"><br /><br /></span>
                                <div class="form-group">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="fas fa-unlock"></i></span>
                                        </div>
                                        <input [type]="hide ? 'password' : 'text'" formControlName="password"
                                            class="form-control form-control-user" placeholder="Password"
                                            style="height:5rem; font-size:medium" required>
                                        <div class="input-group-append">
                                            <button type="button" class="btn-primary text-center" (click)="hide = !hide"
                                                style="padding-left:2rem; padding-right:2rem">
                                                <i *ngIf="!hide" class="fas fa-eye text-white"></i>
                                                <i *ngIf="hide" class="fas fa-eye-slash text-white"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="submitted && f.password.errors">
                                        <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                        Password is required
                                    </div>
                                </div>

                                <div *ngIf="error" class="alert alert-danger text-white" role="alert">
                                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                                    Invalid credentials.
                                </div>

                                <div *ngIf="loading" class="text-center">
                                    <div class="spinner-grow text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="row" style="margin-top: 0%" *ngIf="mobile">
                                    <div class="col">
                                        <button [hidden]="loading" (click)="register()" type="submit"
                                            class="btn btn-primary btn-lg btn-block my-4" id="register"
                                            style="border-radius: 10px">Register your eToro
                                            account</button>
                                    </div>
                                    <div class="col">
                                        <button type="button" [routerLink]="['/login']"
                                            class="btn btn-secondary btn-lg btn-block my-4"
                                            style="border-radius: 10px">Login</button>
                                    </div>
                                </div>
                                <div class="row" *ngIf="!mobile">
                                    <div class="col">
                                        <button [hidden]="loading" (click)="register()" type="submit"
                                            class="btn btn-primary btn-lg btn-block my-4" id="register"
                                            style="border-radius: 10px">Register your eToro
                                            account</button>
                                    </div>
                                    <div class="col">
                                        <button type="button" [routerLink]="['/login']"
                                            class="btn btn-secondary btn-lg btn-block my-4"
                                            style="border-radius: 10px">Login</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">eToro Onboarding</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large">
        Before you can register with Backseat-Trader, you must first have a registered <b>eToro username</b> - this will
        require you to go through the eToro onboarding process.
        <br />
        <br />
        Here is what to expect in eToro Onboarding:

        <ul>
            <li>Date of Birth</li>
            <li>Address</li>
            <li>Proof of Identity</li>
            <li>Tax Information</li>
            <li>Gauging of Trading Knowledge</li>
            <li>Mandatory Trading Quiz</li>
        </ul>
        <br />
        <h2><b>New to eToro - What you need to know:</b></h2>
        <br /><br />

        <br />
        <a (click)="close()">
            <div class="container">
                <div class="row align-items-start justify-content-center no-gutters">
                    <div class="col-md-auto">
                        <span class="hero__play js-play" target="_blank">
                            <img src="assets/img/svg/ico-play.svg" alt="Play button">
                        </span>
                    </div>
                    <div class="col-md-auto">
                        <a [routerLink]="['/academy']">Video Academy - Overview</a>
                    </div>
                </div>
            </div>
        </a>
    </div>
</ng-template>